/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchFeaturedStoreRequest,
    BatchSaveFeaturedStoreResponse,
} from '../models';

export interface FeaturedStoreApiControllerBatchSaveFeaturedStoresRequest {
    batchFeaturedStoreRequest: BatchFeaturedStoreRequest;
}

/**
 * 
 */
export class FeaturedStoreApi extends runtime.BaseAPI {

    /**
     */
    async featuredStoreApiControllerBatchSaveFeaturedStoresRaw(requestParameters: FeaturedStoreApiControllerBatchSaveFeaturedStoresRequest): Promise<runtime.ApiResponse<BatchSaveFeaturedStoreResponse>> {
        if (requestParameters.batchFeaturedStoreRequest === null || requestParameters.batchFeaturedStoreRequest === undefined) {
            throw new runtime.RequiredError('batchFeaturedStoreRequest','Required parameter requestParameters.batchFeaturedStoreRequest was null or undefined when calling featuredStoreApiControllerBatchSaveFeaturedStores.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/featured-stores:batch-save`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchFeaturedStoreRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async featuredStoreApiControllerBatchSaveFeaturedStores(requestParameters: FeaturedStoreApiControllerBatchSaveFeaturedStoresRequest): Promise<BatchSaveFeaturedStoreResponse> {
        const response = await this.featuredStoreApiControllerBatchSaveFeaturedStoresRaw(requestParameters);
        return await response.value();
    }

}
